export const ONETEXT = 'onetext';

export const WILDCARD = '*';

export enum COMPONENT {
    API = 'api',
    WORKER = 'worker'
}

export enum ENV {
    PRODUCTION = 'production',
    SANDBOX = 'sandbox',
    TEST = 'test'
}

export enum PRIORITY {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
    URGENT = 'urgent'
}

export const PRIORITY_ORDER = {
    [ PRIORITY.URGENT ]: 0,
    [ PRIORITY.HIGH ]:   1,
    [ PRIORITY.MEDIUM ]: 2,
    [ PRIORITY.LOW ]:    3
} as const;

export const PRIORITY_ORDER_LIST = [
    PRIORITY.URGENT,
    PRIORITY.HIGH,
    PRIORITY.MEDIUM,
    PRIORITY.LOW
] as const;

export enum MOBILE_PLATFORM {
    IOS = 'ios',
    ANDROID = 'android'
}

export enum DESKTOP_PLATFORM {
    MAC = 'mac',
    WINDOWS = 'windows',
    LINUX = 'linux'
}

export enum DEVICE_TYPE {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    DESKTOP = 'desktop'
}

export enum CACHE_NAMESPACE {
    AI_SESSION = 'ai_session',
    AI_MESSAGE_HISTORY = 'ai_message_history',
    BETA = 'beta',
    CANCEL_TASK = 'cancel_task',
    DB_MEMOIZE = 'db_memoize',
    DYNAMIC_SHORT_LINK = 'dynamic_short_link',
    ERROR_COUNT = 'error_count',
    FEE_UNIT_COUNT = 'fee_unit_count',
    FLOW_GROUP_REPLY_EMAIL = 'flow_group_reply_email',
    INITIALIZE_FLOW = 'initialize_flow',
    LATEST_OUTBOUND_MESSAGE = 'latest_outbound_message',
    LINK_TOKEN = 'link_token',
    LOCK = 'lock',
    MEMOIZE = 'memoize',
    MEMOIZE_RUN = 'memoize_run',
    MOST_RECENT_EVENT = 'most_recent_event',
    NONCE = 'nonce',
    DUPLICATE_ORDER_RECOVERY = 'duplicate_order_recovery',
    POPUP = 'popup',
    ACCOUNT_POPUPS = 'account_popups',
    RATE_LIMIT = 'rate_limit_v3',
    RUN_WITH_CONCURRENCY = 'run_with_concurrency',
    SCHEDULED_TASK_CONCURRENCY = 'scheduled_task_concurrency',
    SCHEDULED_TASK_LOCK = 'scheduled_task_lock',
    SHOPIFY_CART = 'shopify_cart',
    SHOPIFY_RATE_LIMIT = 'shopify_rate_limit',
    SHOPIFY_SHOPPING_SESSION = 'shopify_shopping_session',
    SHORT_TOKEN = 'short_token',
    TEST = 'test',
    TRACKING_DEFER = 'tracking_defer',
    TRACK_WORKER_START_TIMES = 'track_worker_start_times',
    WHATSAPP_CONVERSATION = 'whatsapp_conversation',
    PROPAGATE_MARKETING_PERMISSION_OPT_IN = 'propagate_marketing_permission_opt_in',
    PROPAGATE_MARKETING_PERMISSION_OPT_OUT = 'propagate_marketing_permission_opt_out',
    CUSTOM_FLOW_INSTANCE = 'custom_flow_instance',
    CONVERSATION_ALERTS = 'conversation_alerts',
    SUPPORT_MESSAGE = 'support_message',
    ATTRIBUTION_WINDOW = 'attribution_window',
    RECENTLY_UPDATED_DATABASE_ROW = 'recently_updated_database_row'
}

export enum CACHE_BETA_KEY {
    PRODUCT_SEARCH = 'product_search'
}

export enum ONE_TIME_NONCE_NAMESPACE {
    AUTH_MULTIFACTOR_CODE = 'auth_multifactor_code',
    OPT_IN_MULTIFACTOR_CODE = 'opt_in_multifactor_code',
    STRIPE_CONNECT = 'stripe_connect',
    SHOPIFY_APP_INSTALL = 'shopify_app_install'
}

export enum CACHE_LOCK_NAMESPACE {
    REQUEST = 'request',
    MESSAGE_HANDLER = 'message_handler',
    INITIALIZE_CAMPAIGN = 'initialize_campaign',
    FLOW_STATS_PRECACHE = 'flow_stats_precache',
    ON_SETUP = 'on_setup',
    PRODUCT_SYNC = 'product_sync'
}

export enum PUBSUB_CHANNEL {
    REQUEST_CALLBACK = 'request_callback'
}

export enum ENV_KEY {
    NODE_ENV = 'NODE_ENV',
    VERBOSE = 'VERBOSE',
    PORT = 'PORT',

    API_PROCESS = 'API_PROCESS',
    WORKER_PROCESS = 'WORKER_PROCESS',

    DOPPLER_ACCESS_TOKEN = 'DOPPLER_ACCESS_TOKEN',
    DOPPLER_PROJECT = 'DOPPLER_PROJECT',

    WORKER_PAUSE = 'WORKER_PAUSE',

    DD_AGENT_HOST = 'DD_AGENT_HOST',
    DD_TRACE_AGENT_PORT = 'DD_TRACE_AGENT_PORT',
    DD_SERVICE = 'DD_SERVICE',
    TRACE_SAMPLE_RATE = 'TRACE_SAMPLE_RATE',

    CACHE = 'CACHE',
    MEMORY_CACHE = 'MEMORY_CACHE',

    SECRET = 'SECRET',

    PHONE_PROVIDER = 'PHONE_PROVIDER',
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',

    LOCALTUNNEL_NAME = 'LOCALTUNNEL_NAME',

    DB_POOL_HOST = 'DB_POOL_HOST',
    DB_POOL_USER = 'DB_POOL_USER',
    DB_POOL_DATABASE = 'DB_POOL_DATABASE',
    DB_POOL_PASSWORD = 'DB_POOL_PASSWORD',
    DB_POOL_PORT = 'DB_POOL_PORT',

    DB_POOL_BIZ_READONLY_HOST = 'DB_POOL_BIZ_READONLY_HOST',
    DB_POOL_BIZ_READONLY_PORT = 'DB_POOL_BIZ_READONLY_PORT',

    DB_POOL_REPORTING_READONLY_HOST = 'DB_POOL_REPORTING_READONLY_HOST',
    DB_POOL_REPORTING_READONLY_PORT = 'DB_POOL_REPORTING_READONLY_PORT',
    DB_POOL_REPORTING_READONLY_USER = 'DB_POOL_REPORTING_READONLY_USER',
    DB_POOL_REPORTING_READONLY_PASSWORD = 'DB_POOL_REPORTING_READONLY_PASSWORD',
    DB_POOL_REPORTING_READONLY_DATABASE = 'DB_POOL_REPORTING_READONLY_DATABASE',

    DB_POOL_BACKUP_HOST = 'DB_POOL_BACKUP_HOST',
    DB_POOL_BACKUP_USER = 'DB_POOL_BACKUP_USER',
    DB_POOL_BACKUP_DATABASE = 'DB_POOL_BACKUP_DATABASE',
    DB_POOL_BACKUP_PASSWORD = 'DB_POOL_BACKUP_PASSWORD',
    DB_POOL_BACKUP_PORT = 'DB_POOL_BACKUP_PORT',

    MONGO_DB_HOST = 'MONGO_DB_HOST',
    MONGO_DB_USER = 'MONGO_DB_USER',
    MONGO_DB_DATABASE = 'MONGO_DB_DATABASE',
    MONGO_DB_PASSWORD = 'MONGO_DB_PASSWORD',
    MONGO_DB_PORT = 'MONGO_DB_PORT',

    MONGO_TRACKING_DB_HOST = 'MONGO_TRACKING_DB_HOST',
    MONGO_TRACKING_DB_USER = 'MONGO_TRACKING_DB_USER',
    MONGO_TRACKING_DB_DATABASE = 'MONGO_TRACKING_DB_DATABASE',
    MONGO_TRACKING_DB_PASSWORD = 'MONGO_TRACKING_DB_PASSWORD',
    MONGO_TRACKING_DB_PORT = 'MONGO_TRACKING_DB_PORT',

    CACHE_HOST = 'CACHE_HOST',
    CACHE_PORT = 'CACHE_PORT',
    CACHE_USER = 'CACHE_USER',
    CACHE_PASS = 'CACHE_PASS',

    DIGITALOCEAN_API_KEY = 'DIGITALOCEAN_API_KEY',

    PAYPAL_CLIENT = 'PAYPAL_CLIENT',
    PAYPAL_SECRET = 'PAYPAL_SECRET',
    PAYPAL_PARTNER_ID = 'PAYPAL_PARTNER_ID',

    PAYPAL_SANDBOX_CLIENT = 'PAYPAL_SANDBOX_CLIENT',
    PAYPAL_SANDBOX_SECRET = 'PAYPAL_SANDBOX_SECRET',
    PAYPAL_SANDBOX_PARTNER_ID = 'PAYPAL_SANDBOX_PARTNER_ID',

    PAYPAL_LEGACY_CLIENT = 'PAYPAL_LEGACY_CLIENT',
    PAYPAL_LEGACY_SECRET = 'PAYPAL_LEGACY_SECRET',

    PAYPAL_SANDBOX_LEGACY_CLIENT = 'PAYPAL_SANDBOX_LEGACY_CLIENT',
    PAYPAL_SANDBOX_LEGACY_SECRET = 'PAYPAL_SANDBOX_LEGACY_SECRET',

    SALESFORCE_JWT_PRIVATE_KEY = 'SALESFORCE_JWT_PRIVATE_KEY',
    SALESFORCE_JWT_ISSUER = 'SALESFORCE_JWT_ISSUER',

    STRIPE_PUBLIC_KEY = 'STRIPE_PUBLIC_KEY',
    STRIPE_PRIVATE_KEY = 'STRIPE_PRIVATE_KEY',
    STRIPE_CLIENT_ID = 'STRIPE_CLIENT_ID',
    STRIPE_ACCOUNT_ID = 'STRIPE_ACCOUNT_ID',
    STRIPE_TEST_PUBLIC_KEY = 'STRIPE_TEST_PUBLIC_KEY',
    STRIPE_TEST_PRIVATE_KEY = 'STRIPE_TEST_PRIVATE_KEY',
    STRIPE_TEST_CLIENT_ID = 'STRIPE_TEST_CLIENT_ID',
    STRIPE_TEST_ACCOUNT_ID = 'STRIPE_TEST_ACCOUNT_ID',
    STRIPE_WEBHOOK_SIGNING_SECRET = 'STRIPE_WEBHOOK_SIGNING_SECRET',

    BITLY_CLIENT_ID = 'BITLY_CLIENT_ID',
    BITLY_CLIENT_SECRET = 'BITLY_CLIENT_SECRET',

    MAVERICK_TERMINAL_ID = 'MAVERICK_TERMINAL_ID',
    MAVERICK_ACCESS_TOKEN = 'MAVERICK_ACCESS_TOKEN',

    SHOPIFY_API_KEY = 'SHOPIFY_API_KEY',
    SHOPIFY_API_SECRET = 'SHOPIFY_API_SECRET',

    TWILIO_ACCOUNT_SID = 'TWILIO_ACCOUNT_SID',
    TWILIO_AUTH_TOKEN = 'TWILIO_AUTH_TOKEN',
    TWILIO_VERIFY_SERVICE_SID = 'TWILIO_VERIFY_SERVICE_SID',

    DEV_SLACK_SIGNING_SECRET = 'DEV_SLACK_SIGNING_SECRET',
    DEV_SLACK_OAUTH_TOKEN = 'DEV_SLACK_OAUTH_TOKEN',
    SLACK_SIGNING_SECRET = 'SLACK_SIGNING_SECRET',
    SLACK_OAUTH_TOKEN = 'SLACK_OAUTH_TOKEN',

    AMPLITUDE_API_KEY = 'AMPLITUDE_API_KEY',
    AMPLITUDE_PROJECT_ID = 'AMPLITUDE_PROJECT_ID',

    SPREEDLY_ENVIRONMENT_KEY = 'SPREEDLY_ENVIRONMENT_KEY',
    SPREEDLY_SECRET = 'SPREEDLY_SECRET',

    OPENNODE_API_KEY = 'OPENNODE_API_KEY',
    OPENNODE_WITHDRAWAL_API_KEY = 'OPENNODE_WITHDRAWAL_API_KEY',

    SENDGRID_API_KEY = 'SENDGRID_API_KEY',

    TELNYX_API_KEY = 'TELNYX_API_KEY',
    TELNYX_PUBLIC_KEY = 'TELNYX_PUBLIC_KEY',

    INFOBIP_SUBDOMAIN = 'INFOBIP_SUBDOMAIN',
    INFOBIP_API_KEY = 'INFOBIP_API_KEY',
    INFOBIP_SIGNATURE_KEY = 'INFOBIP_SIGNATURE_KEY',

    SPACES_KEY = 'SPACES_KEY',
    SPACES_SECRET = 'SPACES_SECRET',

    OPENAI_ORGANIZATION = 'OPENAI_ORGANIZATION',
    OPENAI_SECRET_KEY = 'OPENAI_SECRET_KEY',

    ANTHROPIC_API_KEY = 'ANTHROPIC_API_KEY',
    VOYAGE_API_KEY = 'VOYAGE_API_KEY',
    GEMINI_API_KEY = 'GEMINI_API_KEY',

    LAUNCHDARKLY_SDK_KEY = 'LAUNCHDARKLY_SDK_KEY',

    COMMIT_HASH = 'COMMIT_HASH',

    BROWSERLESS_ENDPOINT = 'BROWSERLESS_ENDPOINT',
    BROWSERLESS_API_KEY = 'BROWSERLESS_API_KEY',

    TWOCAPTCHA_API_KEY = 'TWOCAPTCHA_API_KEY',
    CAPSOLVER_API_KEY = 'CAPSOLVER_API_KEY',

    S3_STATIC_BUCKET = 'S3_STATIC_BUCKET',
    S3_STATIC_REGION = 'S3_STATIC_REGION',
    S3_STATIC_ENDPOINT = 'S3_STATIC_ENDPOINT',
    S3_EPHEMERAL_BUCKET = 'S3_EPHEMERAL_BUCKET',
    S3_EPHEMERAL_REGION = 'S3_EPHEMERAL_REGION',
    S3_EPHEMERAL_ENDPOINT = 'S3_EPHEMERAL_ENDPOINT',

    VITALLY_API_KEY = 'VITALLY_API_KEY',
    VITALLY_SECRET_TOKEN = 'VITALLY_SECRET_TOKEN',

    GITHUB_ACCESS_TOKEN = 'GITHUB_ACCESS_TOKEN',
    GITHUB_PR_WEBHOOK_SECRET = 'GITHUB_PR_WEBHOOK_SECRET',

    CLICKHOUSE_URL = 'CLICKHOUSE_URL',
    CLICKHOUSE_USER = 'CLICKHOUSE_USER',
    CLICKHOUSE_PASSWORD = 'CLICKHOUSE_PASSWORD',

    SENTRY_DSN = 'SENTRY_DSN',

    BING_API_KEY = 'BING_API_KEY',
    BRAVE_API_KEY = 'BRAVE_API_KEY',

    AWS_ACCOUNT_ID = 'AWS_ACCOUNT_ID',
    AWS_DEFAULT_REGION = 'AWS_DEFAULT_REGION',
    AWS_SECRET_ACCESS_KEY = 'AWS_SECRET_ACCESS_KEY',
    AWS_ACCESS_KEY_ID = 'AWS_ACCESS_KEY_ID',
    AWS_SENDER_LAMBDA_SUBNET_IDS = 'AWS_SENDER_LAMBDA_SUBNET_IDS',
    AWS_SENDER_LAMBDA_SECURITY_GROUP_IDS = 'AWS_SENDER_LAMBDA_SECURITY_GROUP_IDS',
    AWS_SENDER_LAMBDA_IAM_ROLE_NAME = 'AWS_SENDER_LAMBDA_IAM_ROLE_NAME',
    AWS_CAMPAIGN_LAMBDA_IAM_ROLE_NAME = 'AWS_CAMPAIGN_LAMBDA_IAM_ROLE_NAME',
    AWS_CONTROL_SCALEUP_QUEUE_NAME = 'AWS_CONTROL_SCALEUP_QUEUE_NAME',
    AWS_CONTROL_SCALE_EVENT_GROUP_NAME = 'AWS_CONTROL_SCALE_EVENT_GROUP_NAME',
    DOPPLER_WEBHOOK_SECRET = 'DOPPLER_WEBHOOK_SECRET',

    GOOGLE_FONTS_API_KEY = 'GOOGLE_FONTS_API_KEY'
}

export enum ENV_BOOLEAN {
    TRUE = 'true',
    ONE = '1',
    FALSE = 'false',
    ZERO = '0'
}

export enum CUSTOM_CONTENT_TYPE {
    WELCOME = 'welcome',
    SUBSCRIPTION_OFFER = 'subscription_offer',
    ORDER_RECOVERY = 'order_recovery',
    ORDER_RECOVERY_REMINDER = 'order_recovery_reminder',
    ORDER_RECOVERY_GREETING = 'order_recovery_greeting',
    SHIPPING_TIME = 'shipping_time',
    ORDER_SHIPPED = 'order_shipped',
    POST_PURCHASE_UPSELL = 'post_purchase_upsell',
    WINBACK = 'winback',
    PRODUCT_VIEW_RECOVERY = 'product_view_recovery',
    BROWSE_RECOVERY = 'browse_recovery'
}

export enum EXPERIMENT {
    TEST = 'test',
    CUSTOM_DOMAIN_SUBDOMAIN_SPLIT = 'custom_domain_subdomain_split_v2',
    DUPLICATE_ORDER_RATE_LIMIT = 'duplicate_order_rate_limit',
    FLOW_START = 'flow_start',
    FLOW_STEP_PROMPT = 'flow_step_prompt',
    FLOW_STEP_SPLIT = 'flow_step_split',
    ORDER_RECOVER_DEBOUNCE = 'order_recover_debounce_v3',
    PAYPAL_VAULT = 'paypal_vault_v2',
    RESTRICTED_INTENT_MATCHING = 'restricted_intent_matching',
    AI_INTENT_MATCHING = 'ai_intent_matching',
    TRANSACTIONAL_MESSAGE_CONSENT = 'transactional_message_consent',
    CART_UPDATE_FLOW = 'cart_update_flow',
    PURCHASE_OFFER_LINK = 'purchase_offer_link',
    PURCHASE_OFFER_SHORTENED_MESSAGE = 'purchase_offer_shortened_message',
    AI_MULTI_PRODUCT_CHOICE = 'ai_multi_product_choice',
    AI_FAQ_AGENT = 'ai_faq_agent'
}

export enum EMAIL_RECEIVER {
    CUSTOMER_SUPPORT = 'customer'
}

export enum LINKED_ACCOUNT_TYPE {
    AUTHORIZE_DOT_NET = 'authorize_dot_net',
    KLAVIYO = 'klaviyo',
    OMNISEND = 'omnisend',
    MAVERICK = 'maverick',
    PAYPAL = 'paypal',
    SHOPIFY = 'shopify',
    WOO = 'woo',
    STRIPE = 'stripe',
    TELNYX = 'telnyx',
    INFOBIP = 'infobip',
    TWILIO = 'twilio',
    SENDLANE = 'sendlane',
    INFOBIP_WHATSAPP = 'infobip_whatsapp',
    META_PIXEL = 'meta_pixel',
    ATTENTIVE = 'attentive',
    POSTSCRIPT = 'postscript',
    DRIP = 'drip'
}

export enum PRODUCT_FEATURE_FLAG {
    DISCOUNT_CODE = 'discount_code',
    LAUNCH_FLOWS = 'launch_flows',
    CUSTOMER_CUSTOM_PROPERTIES = 'customer_custom_properties',
    REFILLS = 'refills'
}

export enum PRODUCT_FEATURE_DISABLE_REASON {
    STOREFRONT_NOT_ENABLED = 'storefront_not_enabled',
    WOO_COMMERCE_NOT_IMPLEMENTED = 'woo_commerce_not_implemented',
    ABOVE_BALANCE_THRESHOLD = 'above_balance_threshold',
    NO_CUSTOMER_CUSTOM_PROPERTIES = 'no_customer_custom_properties',
    REFILLS_NOT_ACTIVE = 'refills_not_active'
}

export const REDACTED = 'REDACTED';

export enum TIME_UNIT {
    MILLISECONDS = 'milliseconds',
    SECONDS = 'seconds',
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks'
}

export enum EXIT_CODE {
    SUCCESS = 0,
    ERROR = 1
}

export enum NODE_ENV {
    DEVELOPMENT = 'development',
    TEST = 'test'
}

export enum SHOP_CATEGORY {
    CLOTHING = 'clothing',
    ELECTRONICS = 'electronics',
    HOME = 'home',
    JEWELRY = 'jewelry',
    FOOD = 'food',
    HEALTH = 'health',
    BEAUTY = 'beauty',
    TOYS = 'toys',
    OTHER = 'other'
}

export enum API_CLIENT {
    ONETEXT_SITE = 'onetext_site',
    EXTERNAL = 'external'
}

export enum RATE_LIMIT_TYPE {
    API_ENDPOINT = 'api_endpoint',
    CART_CONCIERGE = 'cart_concierge',
    CHECKOUT_WELCOME = 'checkout_welcome',
    CHECKOUT_LINK_REMINDER = 'checkout_link_reminder',
    INVOICE_FAILED_NOTIFICATION = 'invoice_failed_notification',
    KLAVIYO_CALL = 'klaviyo_call',
    CART_OR_CHECKOUT_RECOVER = 'order_recovery',
    ORDER_RECOVER_REMINDER = 'order_recover_reminder',
    ORDER_SHIPPED_NOTIFICATION = 'order_shipped_notification',
    BROWSE_AND_PRODUCT_RECOVER = 'product_view_recover',
    RECEIVE_MESSAGE_CUSTOMER = 'receive_sms_customer',
    SEND_SMS = 'send_sms',
    FLOW_STEP_RATE_LIMIT = 'flow_step_rate_limit',
    VALIDATE_ACCOUNT_PASSWORD = 'validate_account_password',
    VALIDATE_TWO_FACTOR_CODE = 'validate_two_factor_code',
    WELCOME = 'welcome',
    FLOW_INSTANCE_GROUP = 'flow_instance_group',
    CAMPAIGN = 'campaign',
    DETERMINE_SMS_CARRIER_FEES = 'determine_sms_carrier_fees',
    CORE_FLOW = 'core_flow',
    EXECUTE_TRIGGER_FLOWS = 'execute_trigger_flows',
    OPENAI = 'openai',
    VOYAGE = 'voyage',
    FLOW_VALIDATION = 'flow_validation',
    PROPAGATE_MARKETING_PERMISSION_PHONE = 'propagate_marketing_permission_phone',
    PROPAGATE_MARKETING_PERMISSION_EMAIL = 'propagate_marketing_permission_email'
}

export enum SORT_DIRECTION {
    ASCENDING = 'ascending',
    DESCENDING = 'descending'
}

export enum PROCESS_SIGNAL {
    SIGINT = 'SIGINT',
    SIGTERM = 'SIGTERM',
    SIGQUIT = 'SIGQUIT'
}

export enum EXPERIMENT_GROUP {
    TEST = 'test',
    CONTROL = 'control'
}

export enum EXPERIMENT_SUBGROUP {
    A = 'a',
    B = 'b'
}

export enum EXPERIMENT_EVENT {
    START = 'start',
    END = 'end'
}
